import * as process from 'process'

export const configs = {
  apiURL: process.env.REACT_APP_API_URL,
  ga4MeasurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID,
}
